export type PriorityScore = 'green' | 'yellow' | 'red'

export const PRIORITY_TOOLTIP: Record<PriorityScore, string> = {
  green:
    'High priority: sexual harassment; discrimination/harassment (not still employed); protected-class basis; whistleblower termination; protected leave termination/retaliation.',
  yellow: 'Needs review — incomplete intake or pending OpenAI scoring.',
  red:
    'Low priority: not in NJ; person/employer in Cumberland, Cape May, Camden, Gloucester, or Mercer County; still employed with discrimination/retaliation allegation.',
}

export const GREEN_SCORE_REASONS: readonly string[] = [
  'Sexual harassment.',
  'Discrimination or harassment and no longer employed with the company.',
  'Discrimination or harassment based on a protected characteristic.',
  'Blew the whistle on illegal conduct and was terminated.',
  'Took a protected leave of absence and was terminated or suffered retaliation.',
]

export const RED_SCORE_REASONS: readonly string[] = [
  'Not in New Jersey.',
  'Person and company in Cumberland, Cape May, Camden, Gloucester, or Mercer County.',
  'Still employed and alleging discrimination or retaliation.',
]

export const YELLOW_SCORE_REASONS: readonly string[] = [
  'Insufficient information — default pending review.',
  'Pending OpenAI intake scoring.',
  'Mixed signals — location or employment status needs verification.',
]
